/**
 * ErrorListItemName  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IErrorListItemNameProps {}

export const ErrorListItemName = React.memo<IErrorListItemNameProps>((props) => {
	const baseClass = BEM("edt-error-list", "item-name");

	return <div className={baseClass.toClassName()} {...props} />;
});

ErrorListItemName.displayName = "ErrorListItemName";
